var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 10.167H12.5M6.667 13.5h3.65M8.333 5h3.334c1.666 0 1.666-.833 1.666-1.666 0-1.667-.833-1.667-1.666-1.667H8.333c-.833 0-1.666 0-1.666 1.667C6.667 5 7.5 5 8.333 5z",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 3.35c2.775.15 4.167 1.175 4.167 4.983v5c0 3.333-.833 5-5 5h-5c-4.167 0-5-1.667-5-5v-5c0-3.8 1.392-4.833 4.167-4.983",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/Order.b6b9493b.svg";
export { SvgOrder as ReactComponent };